import '../styles/ui.css';

const variantClass = {
  primary: 'ui-badge primary',
  success: 'ui-badge success',
  warning: 'ui-badge warning',
  neutral: 'ui-badge neutral',
  danger: 'ui-badge danger'
};

export default function Badge({ children, variant = 'neutral' }) {
  return (
    <span className={variantClass[variant] || variantClass.neutral}>
      {children}
    </span>
  );
}
